module.exports = __webpack_public_path__ + "static/img/rj1.00141b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/rj1.png
// module id = 0uQN
// module chunks = 38